export const EMAIL_FORMAT = /^[^@\s]+@[^@\s]+$/

export const PHONE_FORMAT = /^\+?[0-9]{8,15}$/

export const FULL_NAME_FORMAT =
  /[^0-9\.\,\"\?\!\;\:\#\$\%\&\(\)\*\+\-\/\<\>\=\@\[\]\\\^\_\{\}\|\~]{4,65}/
